import { Box, Typography, IconButton } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import Countdown from "../ui/countdown";
import useUserAction from "../../../hooks/user/useUserAction";
import LanguageSelect from "../../app/languageSelect/languageSelect";
import React from "react";
import Images from "../../../assets";


const PageHeader = ({isUpload = false}) => {
    const { userLogout } = useUserAction();
    return (
        <Box>
                <Box
                    component="img"
                    src={Images.banner}
                    alt="logo"
                    sx={{
                        display:'flex',
                        width: "100%",
                    }}
                />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    mt: 4,
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        mr:2
                    }}
                >
                    <Box
                        component="img"
                        src={Images.logo}
                        alt="logo"
                        sx={{
                            width: "50%",
                            height: "50%",
                            transform: "translateX(-16px)",
                        }}
                    />
                </Box>


                <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                    {isUpload === false && <Countdown/>}
                    <LanguageSelect color={'#000000'}/>
                    <IconButton sx={{ border: "1px solid #DCDCDC", borderRadius: 99 }} onClick={userLogout}>
                        <LogoutIcon  sx={{ color: "#004B88" }} />
                    </IconButton>
                </Box>
            </Box>
        </Box>

    );
};

export default PageHeader;
